import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import { Typeahead } from 'react-bootstrap-typeahead';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';

export default function Create() {

  const history = useHistory();
  const { auditeeId } = useParams();
  const [swal, setSwal] = useAlert();

  const [scopes, setScopes] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedScope, setSelectedScope] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  const handleChangeScope = ({target: { value }}) => setSelectedScope(value);
  const handleChangeDepartment = ({ target: { value }}) => setSelectedDepartment(value);

  const fetchScope = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}scopes`, {
        params: { all: true }
      });

      setScopes(response.data.items);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          title: 'Ops..',
          message: 'Something bad happend during get Scope, please contact administrator!',
        }
      });
    }
  }

  const fetchDepartment = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}departments`, {
        params: { all: true }
      });

      setDepartments(response.data.items);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          title: 'Ops..',
          message: 'Something bad happend during get Department, please contact administrator!',
        }
      });
    }
  }

  const fetchAuditee = async () => {

    try {

      const { data: { SCOPE_ID, DEPT_ID, auditeeUsers }} = await axios.get(`${process.env.REACT_APP_API_HOST}auditees/${auditeeId}`, {
        params: {
          expand: `scope,department`
        }
      });

      setSelectedScope(SCOPE_ID)
      setSelectedDepartment(DEPT_ID)

    } catch (error) {

      if (error.response) {
        return setSwal({
          type: TYPES.ERROR,
          payload: {
            title: 'Ops..',
            message: 'Something bad happend during get Auditee, please contact administrator!',
          }
        });
      }

      setSwal({
        type: TYPES.ERROR,
        payload: {
          title: 'Ops..',
            message: 'Something bad happend, please contact administrator!',
        }
      });
    }
  }

  const handleCreate = async () => {

    try {

      const response = await axios.post(`${process.env.REACT_APP_API_HOST}auditees`, {
        SCOPE_ID: selectedScope,
        DEPT_ID: selectedDepartment,
      });

      setSwal({
        type: TYPES.SUCCESS,
        payload: {
          title: `Create Success`,
          message: `New user successfully created.`,
        }
      });

      history.push(`/admin/auditee/${response.data.AUDITEE_ID}`);

    } catch (error) {
      console.log(error.response)

      if (error.response.status === 422) {

        return setSwal({
          type: TYPES.ERROR,
          payload: {
            title: 'Ops...',
            message: 'Scope and Department already taken!',
          }
        });

      }else if(error.response){
        return setSwal({
          type: TYPES.ERROR,
          payload: {
            title: 'Ops..',
            message: 'Something bad happend, please contact administrator!',
          }
        });
      }

      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleUpdate = async () => {

    try {

      const response = await axios.put(`${process.env.REACT_APP_API_HOST}auditees/${auditeeId}`, {
        SCOPE_ID: selectedScope,
        DEPT_ID: selectedDepartment,
      });

      setSwal({
        type: TYPES.SUCCESS,
        payload: {
          title: `Update Success`,
          message: `New user successfully updated.`,
        }
      });

      history.push(`/admin/auditee/${response.data.AUDITEE_ID}`);

    } catch (error) {

      if (error.response) {
        return setSwal({
          type: TYPES.ERROR,
          payload: {
            title: error.toString(),
            message: error.response.data.pop().message,
          }
        });
      }

      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  useEffect(() => {

    fetchScope();
    fetchDepartment();

    if (auditeeId) {
      fetchAuditee();
    }

  }, []);

  return (
    <>
      {swal}
      <Container fluid>
        <Breadcrumb>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Master
          </Breadcrumb.Item>
          <Breadcrumb.Item onClick={() => history.push(`/admin/auditee`)}>
            Auditee
          </Breadcrumb.Item>
          <Breadcrumb.Item aria-current="page" active>
            Create
          </Breadcrumb.Item>
        </Breadcrumb>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">{auditeeId ? `Edit` : `New`} Auditee Form</Card.Title>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Scope Name</Form.Label>
                      <Typeahead
                        id="scope-selector"
                        labelKey={(option) => option.SCOPE_NAME}
                        options={scopes}
                        selected={scopes.filter((a) => a.SCOPE_ID === selectedScope)}
                        onChange={(selected) => {
                          setSelectedScope(selected.length > 0 ? selected[0].SCOPE_ID : null);
                        }}
                        placeholder="Please Select..."
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Department</Form.Label>
                      <Typeahead
                        id="department-selector"
                        labelKey={(option) => option.DEPT_NAME}
                        options={departments}
                        selected={departments.filter((a) => a.DEPT_ID === selectedDepartment)}
                        onChange={(selected) => {
                          setSelectedDepartment(selected.length > 0 ? selected[0].DEPT_ID : null);
                        }}
                        placeholder="Please Select..."
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row style={{ justifyContent: 'flex-end' }}>
          <Col style={{ width: 'auto', flexGrow: 'unset', flexBasis: 'unset' }}>
            {auditeeId
              ? (<><Button onClick={handleUpdate} variant="success">Update</Button>{' '}</>)
              : (<><Button onClick={handleCreate} variant="primary">Create</Button>{' '}</>)
            }
          </Col>
        </Row>
      </Container>
    </>
  );
}